// ========== Drawer Toggle ==========
document.addEventListener("click", function (event) {
  const drawerButton = event.target.closest(".drawer_menu_title");
  if (!drawerButton) return;

  const drawer = drawerButton.closest(".second_drawer_menu");
  const submenu = drawer?.querySelector(".submenu_main_blocker");
  if (!drawer || !submenu) return;

  // Close all others
  document.querySelectorAll(".second_drawer_menu.open_Mobile_menu").forEach((menu) => {
    if (menu !== drawer) {
      menu.classList.remove("open_Mobile_menu");
      const sub = menu.querySelector(".submenu_main_blocker");
      if (sub) sub.style.maxHeight = null;
    }
  });

  const isOpen = drawer.classList.toggle("open_Mobile_menu");
  submenu.style.maxHeight = isOpen ? `${submenu.scrollHeight}px` : null;
});

// ========== Dropdown Hover (Desktop Only) ==========
const inlineMenu = document.querySelector(".header__inline-menu");
if (inlineMenu) {
  const dropdownItems = inlineMenu.querySelectorAll(".dropdown-item");
  const megaMenus = inlineMenu.querySelectorAll(".mega-menu");
  dropdownItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      item.setAttribute("open", "true");
      document.body.classList.add("header_set");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      document.body.classList.remove("header_set");
    });
  });
  megaMenus.forEach((menu) => {
    menu.addEventListener("mouseenter", () => {
      menu.setAttribute("open", "true");
      menu.classList.add("hover-active");
      document.body.classList.add("header_set");
    });
    menu.addEventListener("mouseleave", () => {
      menu.removeAttribute("open");
      menu.classList.remove("hover-active");
      document.body.classList.remove("header_set");
    });
  });
}

window.addEventListener("load", function () {
  setTimeout(() => {
    const bodyLocation = document.body.getAttribute("data-current-location");
    const localizationAnchor = document.querySelector(".localization-form__select");
    if (bodyLocation === "US") return;
    if (localizationAnchor) {
      localizationAnchor.click();
    }
  }, 500);
});

// ========== Country/Popup Logic ==========
document.addEventListener("click", function (event) {
  const bodyPopup = document.querySelector(".popup_body");
  const countryWrap = document.querySelector(".md-modal__grid__1"); 
  const countryItem = event.target.closest('.md-form__select__country__list-link');
  if(countryItem){
    event.preventDefault();
    setTimeout(() => {
      const showNowBtn = countryWrap.querySelector(".md-btn__primary"); 
      if(showNowBtn){
        showNowBtn.click();
      }
    }, 100);
  }

  if (event.target.closest(".site-selector")) {
    document.body.classList.add("overflow-hidden");
  }
  if (event.target.closest(".md-modal-closeButton")) {
    document.body.classList.remove("overflow-hidden");
  }
  if (event.target.closest(".popup_main")) {
    bodyPopup?.classList.add("popup_body_show");
    document.body.classList.add("overflow-hidden");
  }

  if (event.target.closest(".popup_close, .popup_back")) {
    bodyPopup?.classList.remove("popup_body_show");
    document.body.classList.remove("overflow-hidden");
  }
});

// ========== ESC Key Close ==========
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelector(".country-popup")?.classList.remove("show-popup");
    document.querySelector(".popup_body")?.classList.remove("popup_body_show");
    document.body.classList.remove("overflow-hidden");

    document.querySelectorAll(".mega-menu[open]").forEach((menu) => {
      menu.removeAttribute("open");
      menu.classList.remove("hover-active");
    });

    document.querySelectorAll(".dropdown-item[open]").forEach((item) => {
      item.removeAttribute("open");
    });

    document.body.classList.remove("header_set");
  }
});